import Extend from 'flarum/common/extenders';
import Folder from '../common/Folder';
export default [new Extend.Store().add('pigeonhole-folders', Folder)];